import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

export default observer(function SidebarLinks({ icon, text, link, active, badge }) {
  const navigate = useNavigate()
  const { isCollapsed } = useSidebarCollapse()
  const [showTooltip, setShowTooltip] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const navigateTo = () => navigate(link)

  const getTextColor = () => {
    if (isHovered) return 'text-black dark:text-black'
    if (active) return 'text-rb-green dark:text-rb-green'
    return 'text-rb-black dark:text-white'
  }

  const getBgColor = () => {
    if (isHovered) return 'bg-rb-green dark:bg-rb-green'
    return 'bg-white dark:bg-rb-dark-mode'
  }

  return (
    <div className="relative">
      <button
        className={`flex py-2 items-center w-full px-4 ${isCollapsed ? 'justify-center px-2' : ''} ${getBgColor()} ${getTextColor()}`}
        onClick={navigateTo}
        onMouseEnter={() => {
          setIsHovered(true)
          if (isCollapsed) setShowTooltip(true)
        }}
        onMouseLeave={() => {
          setIsHovered(false)
          setShowTooltip(false)
        }}
      >
        <span className={getTextColor()}>{icon}</span>
        {!isCollapsed && (
          <p className={`ml-4 flex items-center gap-2 ${getTextColor()}`}>
            {text}
            {badge && (
              <span className="px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide rounded-full bg-gray-200 text-gray-600 dark:bg-rb-dark-mode-lighter dark:text-rb-dark-mode-text-grey">
                {badge}
              </span>
            )}
          </p>
        )}
      </button>
      {isCollapsed && showTooltip && (
        <div className="absolute left-full ml-3 px-3 py-2 bg-gray-900 dark:bg-rb-dark-mode-lighter text-white text-sm rounded-md whitespace-nowrap z-[100] shadow-lg pointer-events-none">
          {text}
        </div>
      )}
    </div>
  )
})